// import routeApi from "../pages/masterData/route/apiService";
import { clientApi } from "../pages/masterData/client/apiService";
import { Client } from "../pages/masterData/client/types";
import { Party } from "../pages/masterData/party/types";
import { partyApi } from "../pages/masterData/party/apiService";
import { OutsourcedOwner } from "../pages/vehicle/AddVehicle";
import { projectApi } from "../project/project_module/services/apiService";
import { Project } from "../project/project_module/types";
import {
  Driver,
  PetrolPump,
  Parking,
  Mechanic,
  Cleaner,
  serviceOperatorApi,
  ServiceOperator,
  pickupManApi,
  PickupMan,
  Vehicle,
  vehicleApi,
  Lady,
  Manager,
  staffApi,
  petrolPumpApi,
  parkingApi,
  mechanicApi,
  Route,
  routeApi,
  garageApi,
  Garage,
  ownerApi,
} from "./api";

export type SearchableEntity =
  | "DRIVER"
  | "CLEANER"
  | "LADY"
  | "MANAGER"
  | "PETROL_PUMP"
  | "PARKING"
  | "MECHANIC"
  | "GARAGE"
  | "SERVICE_OPERATOR"
  | "PICKUP_MAN"
  | "VEHICLE"
  | "ROUTE"
  | "CLIENT"
  | "PROJECT"
  | "PARTY"
  | "AREA_MANAGER"
  | "CLUSTER_LEADER"
  | "OUTSOURCED_OWNER";

export interface SearchResult {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

export interface SearchHandler {
  search: (term: string, filters?: any) => Promise<any[]>;
  minSearchLength: number;
  mapResult: (item: any) => any;
}

const searchHandlers: Record<SearchableEntity, SearchHandler> = {
  DRIVER: {
    search: staffApi.searchDrivers,
    minSearchLength: 3,
    mapResult: (driver: Driver) => ({
      id: driver.id,
      name: driver.name,
      contactNumber: driver.contactNumber,
      ...(driver.aadharNumber && { aadharNumber: driver.aadharNumber }),
      ...(driver.employmentType && { employmentType: driver.employmentType }),
      ...(driver.address && { address: driver.address }),
      ...(driver.status && { status: driver.status }),
      ...(driver.joiningDate && { joiningDate: driver.joiningDate }),
      ...(driver.salary && { salary: driver.salary }),
      ...(driver.drivingLicense && { drivingLicense: driver.drivingLicense }),
    }),
  },
  CLEANER: {
    search: staffApi.searchCleaners,
    minSearchLength: 3,
    mapResult: (cleaner: Cleaner) => ({
      id: cleaner.id,
      name: cleaner.name,
      contactNumber: cleaner.contactNumber,
      ...(cleaner.aadharNumber && { aadharNumber: cleaner.aadharNumber }),
      ...(cleaner.employmentType && { employmentType: cleaner.employmentType }),
      ...(cleaner.address && { address: cleaner.address }),
      ...(cleaner.status && { status: cleaner.status }),
      ...(cleaner.joiningDate && { joiningDate: cleaner.joiningDate }),
      ...(cleaner.salary && { salary: cleaner.salary }),
    }),
  },
  LADY: {
    search: staffApi.searchLadies,
    minSearchLength: 2,
    mapResult: (lady: Lady) => ({
      id: lady.id,
      name: lady.name,
      contactNumber: lady.contactNumber,
      ...(lady.aadharNumber && { aadharNumber: lady.aadharNumber }),
      ...(lady.employmentType && { employmentType: lady.employmentType }),
      ...(lady.address && { address: lady.address }),
      ...(lady.status && { status: lady.status }),
      ...(lady.joiningDate && { joiningDate: lady.joiningDate }),
      ...(lady.salary && { salary: lady.salary }),
    }),
  },
  MANAGER: {
    search: staffApi.searchManagers,
    minSearchLength: 2,
    mapResult: (manager: Manager) => ({
      id: manager.id,
      name: manager.name,
      contactNumber: manager.contactNumber,
      ...(manager.aadharNumber && { aadharNumber: manager.aadharNumber }),
      ...(manager.employmentType && { employmentType: manager.employmentType }),
      ...(manager.address && { address: manager.address }),
      ...(manager.status && { status: manager.status }),
      ...(manager.joiningDate && { joiningDate: manager.joiningDate }),
      ...(manager.salary && { salary: manager.salary }),
    }),
  },
  AREA_MANAGER: {
    search: staffApi.searchManagers,
    minSearchLength: 2,
    mapResult: (manager: Manager) => ({
      id: manager.id,
      name: manager.name,
      contactNumber: manager.contactNumber,
      ...(manager.aadharNumber && { aadharNumber: manager.aadharNumber }),
      ...(manager.employmentType && { employmentType: manager.employmentType }),
      ...(manager.address && { address: manager.address }),
      ...(manager.status && { status: manager.status }),
      ...(manager.joiningDate && { joiningDate: manager.joiningDate }),
      ...(manager.salary && { salary: manager.salary }),
    }),
  },
  CLUSTER_LEADER: {
    search: staffApi.searchManagers,
    minSearchLength: 2,
    mapResult: (manager: Manager) => ({
      id: manager.id,
      name: manager.name,
      contactNumber: manager.contactNumber,
      ...(manager.aadharNumber && { aadharNumber: manager.aadharNumber }),
      ...(manager.employmentType && { employmentType: manager.employmentType }),
      ...(manager.address && { address: manager.address }),
      ...(manager.status && { status: manager.status }),
      ...(manager.joiningDate && { joiningDate: manager.joiningDate }),
      ...(manager.salary && { salary: manager.salary }),
    }),
  },
  PETROL_PUMP: {
    search: petrolPumpApi.search,
    minSearchLength: 2,
    mapResult: (pump: PetrolPump) => ({
      id: pump.id,
      petrolPumpName: pump.petrolPumpName,
      primaryContactNumber: pump.primaryContactNumber,
      location: pump.location,
      providerName: pump.providerName,
    }),
  },
  PARKING: {
    search: parkingApi.search,
    minSearchLength: 2,
    mapResult: (parking: Parking) => ({
      id: parking.id,
      name: parking.name,
      contactNumber: parking.contactNumber,
      location: parking.location,
    }),
  },
  MECHANIC: {
    search: mechanicApi.search,
    minSearchLength: 2,
    mapResult: (mechanic: Mechanic) => ({
      id: mechanic.id,
      name: mechanic.name,
      phoneNumber: mechanic.phoneNumber,
      location: mechanic.location,
    }),
  },
  GARAGE: {
    search: garageApi.search,
    minSearchLength: 2,
    mapResult: (garage: Garage) => ({
      id: garage.id,
      name: garage.name,
      contactNumber: garage.contactNumber,
      location: garage.location,
      contactName: garage.contactName,
    }),
  },
  SERVICE_OPERATOR: {
    search: serviceOperatorApi.search,
    minSearchLength: 2,
    mapResult: (operator: ServiceOperator) => ({
      id: operator.id,
      name: operator.name,
      type: operator.type,
      contactPerson: operator.contactPerson,
      contactNumber: operator.contactNumber,
      pickupLocation: operator.pickupLocation || "",
      pricingType: operator.pricingType || "",
      pricingValue: operator.pricingValue || "",
      gstPercentage: operator.gstPercentage || 0,
    }),
  },
  PICKUP_MAN: {
    search: pickupManApi.search,
    minSearchLength: 2,
    mapResult: (pickupMan: PickupMan) => ({
      id: pickupMan.id,
      name: pickupMan.name,
      contactNumber: pickupMan.contactNumber,
      location: pickupMan.location || "",
      commissionType: pickupMan.commissionType || "",
      status: pickupMan.status || "",
      commissionValue: pickupMan.commissionValue || "",
    }),
  },
  VEHICLE: {
    search: vehicleApi.search,
    minSearchLength: 2,
    mapResult: (vehicle: Vehicle) => ({
      id: vehicle.id,
      status: vehicle.status,
      vehicleNumber: vehicle.vehicleNumber,
      ...(vehicle.vehicleType && { vehicleType: vehicle.vehicleType }),
      ...(vehicle.acquisitionType && {
        acquisitionType: vehicle.acquisitionType,
      }),
      ...(vehicle.chassisNumber && { chassisNumber: vehicle.chassisNumber }),
      ...(vehicle.engineNumber && { engineNumber: vehicle.engineNumber }),
      ...(vehicle.makeYear && { makeYear: vehicle.makeYear }),
      ...(vehicle.model && { model: vehicle.model }),
      ...(vehicle.color && { color: vehicle.color }),
      ...(vehicle.bodyType && { bodyType: vehicle.bodyType }),
      ...(vehicle.configuration && { configuration: vehicle.configuration }),
      ...(vehicle.fuelType && { fuelType: vehicle.fuelType }),
      ...(vehicle.seatingCapacity && {
        seatingCapacity: vehicle.seatingCapacity,
      }),
      ...(vehicle.isAC && { isAC: vehicle.isAC }),
    }),
  },
  ROUTE: {
    search: routeApi.search,
    minSearchLength: 2,
    mapResult: (route: Route) => ({
      id: route.id,
      name: route.name,
      fromLocation: route.fromLocation,
      toLocation: route.toLocation,
      routeManagerName: route.routeManagerName,
      routeManagerNumber: route.routeManagerNumber,
      ...(route.stops && { stops: route.stops }),
      ...(route.schedules && { schedules: route.schedules }),
    }),
  },
  CLIENT: {
    search: clientApi.getClients,
    minSearchLength: 2,
    mapResult: (client: Client) => ({
      id: client.id,
      clientName: client.clientName,
      primaryContactName: client.primaryContactName,
      primaryContactNumber: client.primaryContactNumber,
      ...(client.email && { email: client.email }),
      ...(client.address && { address: client.address }),
    }),
  },
  PROJECT: {
    search: async (term: string) => {
      const projects = await projectApi.getProjects({ search: term });
      return projects;
    },
    minSearchLength: 2,
    mapResult: (project: Project) => ({
      id: project.id,
      projectName: project.name,
      clientName: project.client?.clientName || "",
      name: project.name,
      ...(project.client && { client: project.client }),
    }),
  },
  PARTY: {
    search: partyApi.search,
    minSearchLength: 2,
    mapResult: (party: Party) => ({
      id: party.id,
      name: party.partyName,
      contactName: party.primaryContactName,
      contactNumber: party.primaryContactNumber,
      ...(party.email && { email: party.email }),
      ...(party.address && { address: party.address }),
    }),
  },
  OUTSOURCED_OWNER: {
    search: async (term: string) => {
      const owners = await ownerApi.getOutsourcedOwners(term);
      return owners;
    },
    minSearchLength: 2,
    mapResult: (owner: OutsourcedOwner) => ({
      id: owner.id,
      name: owner.primaryContactName,
      contactNumber: owner.primaryContactNumber,
      companyName: owner.companyName,
      ...(owner.gstPercentage && { gstPercentage: owner.gstPercentage }),
    }),
  },
};

export class SearchService {
  private static instance: SearchService;
  private searchResults: Map<string, SearchResult> = new Map();

  private constructor() {}

  static getInstance(): SearchService {
    if (!SearchService.instance) {
      SearchService.instance = new SearchService();
    }
    return SearchService.instance;
  }

  async search(
    entity: SearchableEntity,
    searchTerm: string,
    onResults: (results: any[]) => void,
    onError: (error: string) => void,
    onLoading: (loading: boolean) => void,
    filters?: any,
  ): Promise<void> {
    const handler = searchHandlers[entity];

    if (!handler) {
      onError(`No search handler found for entity: ${entity}`);
      return;
    }

    try {
      onLoading(true);
      const results = await handler.search(searchTerm, filters || {});
      const mappedResults = results.map(handler.mapResult);
      onResults(mappedResults);
    } catch (error) {
      onError(`Failed to search ${entity.toLowerCase()}`);
      console.error(`Error searching ${entity}:`, error);
    } finally {
      onLoading(false);
    }
  }

  getSearchResult(entity: SearchableEntity): SearchResult {
    return (
      this.searchResults.get(entity) || {
        data: [],
        isLoading: false,
        error: null,
      }
    );
  }

  setSearchResult(entity: SearchableEntity, result: SearchResult): void {
    this.searchResults.set(entity, result);
  }

  clearSearchResult(entity: SearchableEntity): void {
    this.searchResults.delete(entity);
  }
}

export default SearchService.getInstance();
